import { useEffect, useState } from 'react';
import { useThresholdStore } from './use-threshold-store';
import { getWaterThresholds } from '../../../api/api';

export const useFetchThreshold = (deviceId, isCounter) => {
  const { threshold, setThreshold, updateStatusThreshold } = useThresholdStore();
  const [status, setStatus] = useState(false);

  useEffect(() => {
    if (isCounter) {
      const fetch = async () => {
        await getWaterThresholds(deviceId, (data) => {
          setThreshold(data);
          setStatus(Boolean(data?.is_active));
        });
      };
      fetch();
    }
    return () => {
      setThreshold(null);
    };
  }, []);

  // const toggleThreshold = async (deviceId) => {
  //   if (deviceId && threshold) {
  //     const body = { device_id: deviceId, daily_threshold: Number(threshold) };
  //     await updateWaterThreshold(body, function (err) {
  //       toast.error(err.error, { hideProgressBar: true });
  //     });
  //     setThreshold(null);
  //   }
  // };

  return { threshold, setThreshold, status, setStatus, updateStatusThreshold };
};

export default useFetchThreshold;
